import App from 'ui';

import Layout from '@/components/layouts/Layout';

export default function MyApp({ Component, pageProps, serverRouter }) {
  const type = process.env.NEXT_PUBLIC_LANDING_TYPE || '';
  let headerProps = Component.headerProps || {};
  if (typeof headerProps === 'function') {
    headerProps = headerProps({ query: serverRouter?.query || {} });
  }
  const withLayout = Component.getLayout
    || ((page) => <Layout headerProps={headerProps} name={type}>{page}</Layout>);
  return (
    <App
      title={`My Personality ${type.toUpperCase()}`}
      component={Component}
      gtmKey={process.env.NEXT_PUBLIC_GTM_CONTAINER || 'GTM-55GZ2MR'}
      posthogKeyKey={process.env.NEXT_PUBLIC_POSTHOG_API_KEY}
    >
      {withLayout(<Component {...pageProps} />)}
    </App>
  );
}
